module.exports = __webpack_public_path__ + "img/avt.7b96d468.png";